import { useEffect, useState, useRef } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import GraficoVentasOficial from "../components/GraficoVentasOficial";
import API from "../api";

const nombresMeses = [
  "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
  "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"
];

const Ventas = () => {
  const [datos, setDatos] = useState([]);
  const [filtros, setFiltros] = useState({ anios: [], meses: [], razones: [], usuarios: [] });
  const [seleccion, setSeleccion] = useState({ anios: [], meses: [], razones: [], usuarios: [] });
  const [aplicados, setAplicados] = useState({ anios: [], meses: [], razones: [], usuarios: [] });
  const [mostrarDropdown, setMostrarDropdown] = useState({ anios: false, meses: false, razones: false, usuarios: false });

  const refAnios = useRef();
  const refMeses = useRef();
  const refRazones = useRef();
  const refUsuarios = useRef();

  useEffect(() => {
    fetch(`${API}/VentasOficial`)
      .then((res) => res.json())
      .then((data) => {
        setDatos(data);

        const aniosUnicos = [...new Set(
          data.map((d) => {
            if (!d.FECHA || typeof d.FECHA !== "string") return null;
            const partes = d.FECHA.split("-");
            return partes.length === 3 ? parseInt(partes[2]) : null;
          }).filter(Boolean)
        )].sort((a, b) => a - b);

        const mesesUnicos = [...new Set(
          data.map((d) => {
            if (!d.FECHA || typeof d.FECHA !== "string") return null;
            const partes = d.FECHA.split("-");
            return partes.length === 3 ? parseInt(partes[1]) : null;
          }).filter(Boolean)
        )].sort((a, b) => a - b);

        const razonesUnicas = [...new Set(data.map(d => d["RAZON SOCIAL"]))].sort();
        const usuariosUnicos = [...new Set(data.map(d => d.USUARIO))];

        setFiltros({ anios: aniosUnicos, meses: mesesUnicos, razones: razonesUnicas, usuarios: usuariosUnicos });
      });
  }, []);

  useEffect(() => {
    const clickFuera = (e) => {
      if (!refAnios.current?.contains(e.target) && !refMeses.current?.contains(e.target) && !refRazones.current?.contains(e.target) && !refUsuarios.current?.contains(e.target)) {
        setMostrarDropdown({ anios: false, meses: false, razones: false, usuarios: false });
      }
    };
    document.addEventListener("mousedown", clickFuera);
    return () => document.removeEventListener("mousedown", clickFuera);
  }, []);

  const toggleDropdown = (tipo) => {
    setMostrarDropdown({ anios: false, meses: false, razones: false, usuarios: false, [tipo]: true });
  };

  const toggleValor = (valor, tipo) => {
    setSeleccion(prev => ({
      ...prev,
      [tipo]: prev[tipo].includes(valor) ? prev[tipo].filter(v => v !== valor) : [...prev[tipo], valor]
    }));
  };

  const aplicarFiltros = () => {
    setAplicados({ ...seleccion });
  };

  const limpiarFiltros = () => {
    setSeleccion({ anios: [], meses: [], razones: [], usuarios: [] });
    setAplicados({ anios: [], meses: [], razones: [], usuarios: [] });
  };

  const datosFiltrados = datos.filter(d => {
    if (!d.FECHA || typeof d.FECHA !== "string") return false;

    const partes = d.FECHA.split("-");
    if (partes.length !== 3) {
      console.warn("⛔️ Formato no válido de fecha:", d.FECHA);
      return false;
    }
    const anio = parseInt(partes[2]);
    const mes = parseInt(partes[1]);
    if (isNaN(anio) || isNaN(mes)) return false;

    return (
      (aplicados.anios.length === 0 || aplicados.anios.includes(anio)) &&
      (aplicados.meses.length === 0 || aplicados.meses.includes(mes)) &&
      (aplicados.razones.length === 0 || aplicados.razones.includes(d["RAZON SOCIAL"])) &&
      (aplicados.usuarios.length === 0 || aplicados.usuarios.includes(d.USUARIO))
    );
  });

  const documentosValidos = datosFiltrados.filter(d => d.DOCUMENTO === "FACTURA ELECTRONICA" || d.DOCUMENTO === "NOTA DE DEBITO ELECTRONICA");
  const notasCredito = datosFiltrados.filter(d => d.DOCUMENTO === "NOTA DE CREDITO ELECTRONICA");

  const totalNeto = documentosValidos.reduce((sum, d) => sum + (d.NETO || 0), 0);
  const totalIVA = documentosValidos.reduce((sum, d) => sum + (d.IVA || 0), 0);
  const totalTOTAL = documentosValidos.reduce((sum, d) => sum + (d.TOTAL || 0), 0);
  const totalNotasCredito = notasCredito.reduce((sum, d) => sum + (d.TOTAL || 0), 0);
  const totalGeneralReal = totalTOTAL + totalNotasCredito;

  console.log("🧾 Notas de Crédito:", notasCredito);
  console.log("🧾 Total Notas de Crédito:", totalNotasCredito);
  const sinCampos = documentosValidos.filter(d => typeof d.TOTAL !== "number" || typeof d.NETO !== "number" || typeof d.IVA !== "number");
  console.log("⚠️ Documentos válidos sin campos numéricos:", sinCampos);

  return (
    <div className="container my-4">
      {/* Filtros */}
      <div className="bg-light p-4 rounded shadow-sm mb-4">
        <Row className="g-3 align-items-end">
          {[{ ref: refAnios, label: "Año", tipo: "anios" }, { ref: refMeses, label: "Mes", tipo: "meses" }, { ref: refRazones, label: "Razón Social", tipo: "razones" }, { ref: refUsuarios, label: "Usuario", tipo: "usuarios" }].map(({ ref, label, tipo }, idx) => (
            <Col md={2} key={tipo} ref={ref} className="position-relative">
              <label className="form-label fw-semibold">{label}</label>
              <button onClick={() => toggleDropdown(tipo)} className="form-control text-start">
                {seleccion[tipo].length > 0 ? `Seleccionados (${seleccion[tipo].length})` : `-- Todos --`}
              </button>
              {mostrarDropdown[tipo] && (
                <div className="position-absolute bg-white border border-secondary rounded shadow mt-1 z-3 overflow-auto" style={{ maxHeight: "200px", width: "100%" }}>
                  {(tipo === "meses"
                    ? filtros.meses.map((mes) => (
                        <label key={mes} className="dropdown-item">
                          <input type="checkbox" className="form-check-input me-2" checked={seleccion.meses.includes(mes)} onChange={() => toggleValor(mes, "meses")} />
                          {nombresMeses[mes - 1]}
                        </label>
                      ))
                    : filtros[tipo].map((valor, i) => (
                        <label key={i} className="dropdown-item">
                          <input type="checkbox" className="form-check-input me-2" checked={seleccion[tipo].includes(valor)} onChange={() => toggleValor(valor, tipo)} />
                          {valor}
                        </label>
                      )))}
                </div>
              )}
            </Col>
          ))}

          <Col md={4} className="d-flex gap-2 justify-content-end">
            <Button variant="primary" onClick={aplicarFiltros}>Aplicar Filtros</Button>
            <Button variant="danger" onClick={limpiarFiltros}>Limpiar</Button>
          </Col>
        </Row>
      </div>

      {/* Tarjetas resumen */}
      <Row className="mb-4">
        <Col md={3}><Card className="text-center shadow-sm"><Card.Body><h6 className="fw-bold">Total Neto</h6><p className="fs-5">${totalNeto.toLocaleString("es-CL")}</p></Card.Body></Card></Col>
        <Col md={3}><Card className="text-center shadow-sm"><Card.Body><h6 className="fw-bold">Total IVA</h6><p className="fs-5">${totalIVA.toLocaleString("es-CL")}</p></Card.Body></Card></Col>
        <Col md={3}><Card className="text-center shadow-sm bg-light"><Card.Body><h6 className="fw-bold text-danger">Total Nota de Crédito</h6><p className="fs-5 text-danger">-${Math.abs(totalNotasCredito).toLocaleString("es-CL")}</p></Card.Body></Card></Col>
        <Col md={3}><Card className="text-center shadow-sm"><Card.Body><h6 className="fw-bold">Total General Real</h6><p className="fs-5 text-success">${totalGeneralReal.toLocaleString("es-CL")}</p></Card.Body></Card></Col>
      </Row>

      <GraficoVentasOficial datos={documentosValidos} />
    </div>
  );
};

export default Ventas;
